var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 20,
    viewBox: "4 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 4C2.89543 4 2 4.89543 2 6V14C2 15.1046 2.89543 16 4 16H16C17.1046 16 18 15.1046 18 14V6C18 4.89543 17.1046 4 16 4H4ZM4.97885 6.6221C4.494 6.35764 3.88657 6.5363 3.6221 7.02115C3.35764 7.506 3.5363 8.11343 4.02115 8.3779L9.52115 11.3779C9.81963 11.5407 10.1804 11.5407 10.4789 11.3779L15.9789 8.3779C16.4637 8.11343 16.6424 7.506 16.3779 7.02115C16.1134 6.5363 15.506 6.35764 15.0211 6.6221L10 9.36091L4.97885 6.6221Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIcon);
export default __webpack_public_path__ + "static/media/mail-icon.d5786fed54b477e8348effbeeb6f6752.svg";
export { ForwardRef as ReactComponent };